export default "__VITE_ASSET__bb85ce46__"